export type OverlayType = "header" | "footer"

export type State = {
    overlayOpen: boolean
    overlayType: OverlayType | null
    region: string
    loading: boolean
    error: any
}

// what the consumers of useAuthState see: the transient state above plus the derived flags
export type LocalesState = State & {
    language: string
}

export type Action =
    | { type: "PATCH_REGION"; payload: { region: string } }
    | { type: "TOGGLE_OVERLAY"; payload: { type: OverlayType } }
    | { type: "CLOSE_OVERLAY"; payload: { type: OverlayType } }
    | { type: "ERROR"; error: any }

const initialState: State = {
    overlayOpen: false,
    overlayType: null,
    region: "",
    loading: true,
    error: null,
}

const LocalesReducer = (initialState: State, action: Action) => {
    switch (action.type) {
        case "PATCH_REGION":
            return {
                ...initialState,
                region: action.payload.region,
                loading: false,
            }
        case "TOGGLE_OVERLAY":
            return {
                ...initialState,
                overlayOpen: !initialState.overlayOpen,
                overlayType: action.payload.type,
                loading: false,
            }
        case "CLOSE_OVERLAY":
            return {
                ...initialState,
                overlayOpen: false,
                overlayType: action.payload.type,
            }
        case "ERROR":
            return {
                ...initialState,
                error: action.error,
            }
        default:
            throw new Error("Unhandled action type")
    }
}

export { LocalesReducer, initialState }
